import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './EmptyState.module.scss';
import { useSelector } from 'react-redux';
import { getUserInfo } from 'Store/Auth/Auth.selector';
import { PromptCard } from './Message';

const getFirstName = (name?: string) => {
  if (!name) {
    return '';
  }

  const containsSpace = name.includes(' ');
  if (!containsSpace) {
    return name;
  }

  const splitedName = name.split(' ');
  return splitedName[0];
};

export const EmptyState: FC<{ onSelectPrompt: (prompt: string) => void }> = ({
  onSelectPrompt
}) => {
  const { t } = useTranslation('activities');
  const userInfo = useSelector(getUserInfo);

  return (
    <div className={styles['Container']}>
      <div className={styles['ctaContainer']}>
        <div className={styles['badge']}>
          <span className={styles['badgeLabel']}>{t('aiChat.assistantLabel')}</span>
        </div>

        <h1 className={styles['cta-title']}>
          {t('aiChat.greeting')}{' '}
          <span className={styles['gradient-name']}>{getFirstName(userInfo?.Nome)}</span>!
          <span className={styles['subtitle']}>{t('aiChat.subtitleAsk')}</span>
        </h1>

        <p className={styles['paragrafo-prompt']}>
          {t('aiChat.selectPrompt')}
        </p>
      </div>

      <div className={styles['footer']}>
        <PromptCard
          icon="calendar"
          title={t('aiChat.promptWeeklyTitle')}
          description={t('aiChat.promptWeeklyDesc')}
          onClick={() =>
            onSelectPrompt(t('aiChat.promptWeeklyValue'))
          }
        />
        <PromptCard
          icon="alerta"
          title={t('aiChat.promptHighPriorityTitle')}
          description={t('aiChat.promptHighPriorityDesc')}
          onClick={() => onSelectPrompt(t('aiChat.promptHighPriorityValue'))}
        />
        <PromptCard
          icon="disciplinaArquitetura"
          title={t('aiChat.promptDisciplineTitle')}
          description={t('aiChat.promptDisciplineDesc')}
          onClick={() => onSelectPrompt(t('aiChat.promptDisciplineValue'))}
        />
        <PromptCard
          icon="relogio"
          title={t('aiChat.promptOverdueTitle')}
          description={t('aiChat.promptOverdueDesc')}
          onClick={() => onSelectPrompt(t('aiChat.promptOverdueValue'))}
        />
      </div>
    </div>
  );
};
